import { ReactElement } from 'react';
import styled from 'styled-components';

const StyledTable = styled.table`
  margin: 0;
  width: 100%;
  box-shadow:
    rgba(62, 76, 89, 0.02) 0px 1px 2px 0px,
    rgba(82, 96, 109, 0.04) 0px 2px 4px 0px;
  overflow-x: auto;

  thead {
    tr {
      width: 100%;
      height: 48px;
      border-bottom: 1px solid rgb(228, 231, 235);
    }

    th,
    td {
      background: rgba(203, 210, 217, 0.3);
      padding: 16px 8px 12px;
      vertical-align: middle;
      box-sizing: border-box;
      color: rgb(31, 41, 51);
      font-family: Inter, sans-serif;
      font-size: 0.75rem;
      letter-spacing: 0em;
      line-height: 1rem;
      font-weight: 400;
    }
  }

  tbody {
    tr {
      width: 100%;
      height: 48px;
      border-bottom: 1px solid rgb(228, 231, 235);

      &:hover,
      &:focus-within {
        background-color: rgba(245, 247, 250, 0.9) !important;
      }

      &:nth-of-type(odd) {
        background-color: rgba(245, 247, 250, 0.5);
      }
    }

    td {
      font-family: Inter, sans-serif;
      font-size: 0.875rem;
      letter-spacing: 0em;
      line-height: 1.5rem;
      font-weight: 400;
      color: rgb(31, 41, 51);
      padding: 12px 8px;
      vertical-align: middle;
      box-sizing: border-box;
      width: 150px;
    }
  }

  tfoot {
    tr {
      width: 100%;
      height: 48px;
      border-bottom: 1px solid rgb(228, 231, 235);
    }

    td {
      background: rgba(203, 210, 217, 0.3);
      padding: 16px 8px 12px;
      vertical-align: middle;
      box-sizing: border-box;
      color: rgb(31, 41, 51);
      font-family: Inter, sans-serif;
      font-size: 0.875rem;
      letter-spacing: 0em;
      line-height: 1rem;
      font-weight: 600;
    }
  }
`;

export const Table = ({
  thead,
  tbody,
  tfoot,
}: {
  thead: ReactElement;
  tbody: ReactElement;
  tfoot?: ReactElement;
}) => {
  return (
    <StyledTable>
      <thead>{thead}</thead>
      <tbody>{tbody}</tbody>
      <tfoot className="fw-semibold">{tfoot}</tfoot>
    </StyledTable>
  );
};

export const TableRow = styled.tr<{ $selected?: boolean; $error?: boolean }>`
  background: ${(props) =>
    (props.$error && '#FFCBCB ') || (props.$selected && '#C6F7E9 ')} !important;
  &:hover td,
  &:focus-within td {
    background-color: ${(props) =>
      (props.$error && '#FF9B9B ') || (props.$selected && '#8EEDD1 ')} !important;
  }
`;
